"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavButtonGroup = exports.NavButton = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../space/index");
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "children", "icon", "iconSelected"],
  _excluded2 = ["className", "children", "title"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable */
var StyledNavButton = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  componentId: "kds-v1__sc-bimkem-0"
})(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;width:228px;", ";", " font-style:normal;border-radius:16px;border:0;span{", ";}cursor:pointer;", " ", " &:enabled{&:hover{", "}&:active:not(focus){", "}}&:disabled{", " cursor:default;}", ""], _kDsFoundation["default"].setSpacingWithFallback('padding: ', 'spacing-04', 'spacing-05'), _kDsFoundation["default"].setTypographyWithFallback({
  'font-family': 'font-primary',
  'font-weight': 'font-bold',
  'font-size': 'text-base',
  'letter-spacing': 'tracking-wide',
  'line-height': 'normal'
}), _kDsFoundation["default"].setSpacingWithFallback('margin-left: ', 'spacing-05'), _kDsFoundation["default"].setColorWithFallback('background: ', 'transparent'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-primary'), _kDsFoundation["default"].setColorTokenWithFallback('background: ', 'background-alternate'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'interactive-primary'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-placeholder'), function (props) {
  return props.selected && (0, _styledComponents.css)(["", " ", " cursor:default;"], _kDsFoundation["default"].setColorTokenWithFallback('background: ', 'background-alternate'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'interactive-primary'));
});
/* eslint-enable */

var NavButton = exports.NavButton = function NavButton(_ref) {
  var className = _ref.className,
    children = _ref.children,
    icon = _ref.icon,
    iconSelected = _ref.iconSelected,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var selected = moreProps.selected;
  var iconToRender = icon;
  if (selected && iconSelected) {
    iconToRender = iconSelected;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledNavButton, _extends({
    className: className
  }, moreProps), iconToRender, /*#__PURE__*/_react["default"].createElement("span", null, children));
};

/* eslint-disable */
var StyledNavButtonGroup = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-bimkem-1"
})(["display:flex;flex-direction:column;align-items:center;", " .group-title{align-self:flex-start;", " font-style:normal;", " ", ";}"], _kDsFoundation["default"].setColorWithFallback('background: ', 'transparent'), _kDsFoundation["default"].setTypographyWithFallback({
  'font-family': 'font-primary',
  'font-weight': 'font-bold',
  'font-size': 'text-xs',
  'letter-spacing': 'tracking-wide',
  'line-height': 'snug'
}), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'interactive-secondary'), _kDsFoundation["default"].setSpacingWithFallback('margin: ', 0, 0, 'spacing-04', 'spacing-06'));
/* eslint-enable */

var NavButtonGroup = exports.NavButtonGroup = function NavButtonGroup(_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    title = _ref2.title,
    moreProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(StyledNavButtonGroup, _extends({
    className: className
  }, moreProps), title ? /*#__PURE__*/_react["default"].createElement("h2", {
    className: "group-title"
  }, title) : null, /*#__PURE__*/_react["default"].createElement(_index.Space, {
    size: "medium",
    direction: "vertical",
    align: "center"
  }, children));
};